import { css } from 'styled-components';
import { colorsV2 } from '../../../../colors-v2';

export const blockQuoteStyle = css`
  blockquote {
    background: #fafafa;
    box-shadow: inset 4px 0 0 ${colorsV2.black100};
    margin: 0;
    padding: 24px;
    display: grid;
    gap: 16px;
    position: relative;

    > p {
      font-family: noto-serif, serif;
      font-weight: 300;
      font-size: 20px;

      white-space: pre-wrap;
      word-break: break-word;

      &:before {
        content: '“';
      }

      &:after {
        content: '”';
      }
    }
    > cite {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;

      color: ${colorsV2.black100};
      &:before {
        content: '--';
        color: ${colorsV2.black100};
        display: inline;
      }
      white-space: pre-wrap;
      word-break: break-word;
    }
  }
`;
